import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForProductComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'categoryId',
      type: 'selectValueLabel',
      options: [166, 164, 165],
    },
    {
      key: 'customFilter',
      type: 'selectCustom',
      options: [
        { property: 'text', value: 'NOTEMPTY' },
        { property: 'subheadline', value: 'NOTEMPTY' },
      ],
    },
  ];

  defaultColumns = [
    'id',
    'headline',
    'releaseDate',
    'sku',
    'contributors',
    'categoryId2',
    'categoryId3',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'releaseDate',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
    },
    {
      property: 'sku',
      sortable: true,
    },
    {
      property: 'contributors',
      relationPath: 'artist',
      relationLabel: 'artist.displayLabel',
      relationLink: false,
      type: 'relation',
    },
    {
      property: 'categoryId2',
      type: 'relation',
    },
    {
      property: 'categoryId3',
      type: 'relation',
    },
    {
      property: 'categoryId4',
      type: 'relation',
    },
    {
      property: 'categoryId',
      type: 'relation',
    },
    {
      property: 'categoryId1',
      type: 'relation',
    },
    {
      property: 'country',
      sortable: true,
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
